module.exports = __webpack_public_path__ + "static/media/imagemGED.aa3a9a73.svg";